import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActivitylogService {

  constructor(private httpClient: HttpClient) { }
  readonly rootURL = environment.ImpataAppAPIRoot;
  req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });

  getActivityLogs(page: number, offset : number, moduleId: number, paramsForFilter: Array<any>) {
    let object = {page: page, offset: offset, moduleId: moduleId, filters: paramsForFilter}
    let url = this.rootURL + `activity/getactivitylog`;
   
    return this.httpClient.get(url, {params: {data: JSON.stringify(object)}});
  }
 
}
